import { render } from "./DashboardAdminPayout.vue?vue&type=template&id=2742840c&scoped=true"
import script from "./DashboardAdminPayout.vue?vue&type=script&lang=js"
export * from "./DashboardAdminPayout.vue?vue&type=script&lang=js"

import "./DashboardAdminPayout.vue?vue&type=style&index=0&id=2742840c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2742840c"]])

export default __exports__